import styled, { css } from "styled-components";
import { glow } from "theme";

import FnrShineButton, {
  FnrShineButtonWrapper,
} from "UI/FnrButton3/FnrShineButton";

import dynBackgroundColor from "Utilities/interpolations/dynBackgroundColor";
import flash from "Utilities/interpolations/flash";

export const iconPaddingRight = 10;

export const floatingButtonStyles = css`
  border-radius: 24px;
  backdrop-filter: blur(4px);
  ${glow}
  ${flash}
`;

export const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  padding: 4px 8px 6px;
  border-radius: 24px;
`;

export const FloatingButton = styled(FnrShineButton)`
  ${floatingButtonStyles}
  ${dynBackgroundColor}
  transition: background-color 200ms;

  ${FnrShineButtonWrapper} {
    height: 32px;
  }
`;
